(function Module() {
	'use strict';

	mySynch.factory('F360Service', [
		'$location',
		'MySynchFactory',
		'F360Constant',
		function f360Service($location,MSF, constant) {
			return {
				getReport360Breadcrumbs: function getReport360Breadcrumbs(publishedDate='') {
					var url = $location.url();
					var breadcrumbs = [{'name':'Fertility 360 Report', 'url':'#/f360', 'heading': ''}];
					var breadcrumbSection = [
						{'link':'evaluation-overview', 'text':'Evaluation Overview'},
						{'link':'result-write-report', 'text':'Results & Write Report'},
						{'link':'review-draft-report', 'text':'Review Draft Report'},
					];
					
					var codeFile = _.cloneDeep(_.get(MSF, 'lists.codeFile', []));
					var arrSection = _.filter(codeFile, {codeType: 'F360SECTION'});
					arrSection.forEach(item => {
						var lowercase = item.codeValue.toLowerCase();
						var sectionLink = lowercase.replace(/ /g, "-");
						var section = {'link': sectionLink, 'text': item.codeValue};
						breadcrumbSection.push(section);
						if (item.detailsJson.length > 0) {
							var detailsJson = JSON.parse(item.detailsJson);
							if (detailsJson[0].subHeadings) {
								var description = '';
								detailsJson[0].subHeadings.forEach(sub => {
									if (sub.description) {
										description = sub.description;
										lowercase = sub.description.toLowerCase();
									} else {
										description = sub.Description;
										lowercase = sub.Description.toLowerCase();
									}
									
									sectionLink = lowercase.replace(/ /g, "-");
									var isExist = _.find(breadcrumbSection, {link: sectionLink});
									if (!isExist) {
										var subHeading = {'link': sectionLink, 'text': description};
										breadcrumbSection.push(subHeading);
									}
								});
							}
						}
					});

					var segments = url.split("/");
					var link = '';
					if (segments.length > 2) {
						if (segments.length == 3) {
							link = {'name': `Report ${publishedDate}`, 'url':`#/${segments[1]}/${segments[2]}`, 'heading': ''};
							breadcrumbs.push(link);
						} else {
							if (segments.length > 3) {
								var segment2 = _.find(breadcrumbSection, {link: segments[3]});
								if (segment2) {
									link = {'name': segment2.text, 'url':`#/${segments[1]}/${segments[2]}/${segments[3]}`, 'heading': ''};
									breadcrumbs.push(link);
									if (segments.length > 4) {
										var segment3 = _.find(breadcrumbSection, {link: segments[4]});
										if (segment3) {
											link = {'name': segment3.text, 'url':`#/${segments[1]}/${segments[2]}/${segments[3]}/${segments[4]}`, 'heading': ''};
											breadcrumbs.push(link);
										}
									}
									if (segments.length > 6) {
										var segment5 = _.find(breadcrumbSection, {link: segments[6]});
										if (segment5) {
											var heading = _.find(breadcrumbSection, {link: segments[5]});
											link = {'name': segment5.text, 'url':`#/${segments[1]}/${segments[2]}/${segment2.link}/${segments[4]}/${segments[5]}/${segments[6]}`, 'heading': heading.text};
											breadcrumbs.push(link);
										}
									} else if (segments.length > 5) {
										var segment4 = _.find(breadcrumbSection, {link: segments[5]});
										if (segment4) {
											link = {'name': segment4.text, 'url':`#/${segments[1]}/${segments[2]}/${segments[3]}/${segments[4]}/${segments[5]}`, 'heading': ''};
											breadcrumbs.push(link);
										}
									}
								}
							}
						}
					}
					return breadcrumbs;
				},
				generateUUID() {
					var d = new Date().getTime();
					var d2 = (performance && performance.now && (performance.now()*1000)) || 0;
					var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
						var r = Math.random() * 16;
						if(d > 0){
							r = (d + r)%16 | 0;
							d = Math.floor(d/16);
						} else {
							r = (d2 + r)%16 | 0;
							d2 = Math.floor(d2/16);
						}
						return (c=='x' ? r : (r&0x7|0x8)).toString(16);
					});
					return uuid;
				}
			};
		}
	]);
})();
